var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('span',{staticClass:"logo-icon"}),_c('span',{staticClass:"logo-text"},[_vm._v(" "+_vm._s(_vm.$t('bi.header.company'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }